import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Request } from '../types';
//
// Все мои запросы
//
export type RequestsState = Request[];
const initialState = [] as RequestsState; 

export const requestsSlice = createSlice({
    name: 'requests',
    initialState,
    reducers: {
        requestsSet: (state, action: PayloadAction<RequestsState>) => {
            return action.payload;
        },
        requestsAdd: (state, action: PayloadAction<Request>) => {
            state.push(action.payload);
        },
        requestsDel: (state, action: PayloadAction<number>) => {
            const index = state.findIndex(r => r.id === action.payload);
            if(index >= 0) {
                state.splice(index, 1);
            }
        },
        requestsPut: (state, action: PayloadAction<Request>) => {
            const index = state.findIndex(r => r.id === action.payload.id);
            if(index >= 0) {
                state[index] = action.payload;
            }
        },
    }
});

export const { requestsSet, requestsAdd, requestsDel, requestsPut } = requestsSlice.actions;
export default requestsSlice.reducer;
